import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-rock': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M408.9 79.1C386.5 45.2 342.8 36.8 310.1 55.5 280.6 24 230.9 24.4 201.7 55.4 154.6 28.4 93 60.5 91 116.2 44.8 105.4 0 140 0 187.4V244.4C0 277.1 14.3 308.3 39.2 330L136.9 415.1C141.1 418.8 140 420.7 140 448 140 465.7 154.3 480 172 480H424C441.7 480 456 465.7 456 448 456 424.5 455 417.3 460 405.6L502.8 306C508.9 291.8 512 276.8 512 261.4V147C512 94.1 457.7 58.3 408.9 79.1zM464 261.4A64.5-64.5 0 0 0 458.7 287L415.9 386.7C410.7 398.8 408 411.7 408 424.9V432H188V421.7C188 405.3 180.9 389.7 168.4 378.9L70.7 293.8C56.3 281.3 48 263.2 48 244.4V187.4C48 154.2 100 153.9 100 188.1V229.3A16-16 0 0 1 105.5 241.4L112.5 247.5A16-16 0 0 1 139 235.4V118.9C139 85.8 191 85.1 191 119.5V146.3C191 155.1 198.2 162.3 207 162.3H214C222.8 162.3 230 155.1 230 146.3V105.1C230 72 282 71.5 282 105.8V146.3C282 155.1 289.2 162.3 298 162.3H305C313.8 162.3 321 155.1 321 146.3V118.9C321 85.8 373 85.1 373 119.5V146.3C373 155.1 380.2 162.3 389 162.3H396C404.8 162.3 412 155.1 412 146.3 412 113.1 464 112.7 464 147V261.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-rock.js
// module id = bN6i
// module chunks = 144